import { useAuth } from './AuthProvider';

// Visibility only: the backend independently enforces every admin operation.
export default function AdminOnly({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin === true ? children : null;
}
